// import logo from './logo.svg';
// import './App.css';

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

// export default App;


// import React from "react";
// import { Routes, Route } from "react-router-dom";
// import Navbar from "./components/Navbar";
// import ProductTable from "./components/ProductTable";
// import CategoryTable from "./components/CategoryTable";

// const App = () => {
//   return (
//     <div>
//       <Navbar />
//       <Routes>
//         <Route path="/" element={<ProductTable />} />
//         <Route path="/categories" element={<CategoryTable />} />
//       </Routes>
//     </div>
//   );
// };

// export default App;


import React from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

import "./App.css";
import Login from "./components/Login";
import ProductTable from "./components/ProductTable";
import CategoryPage from "./components/CategoryPage";
import ProductPage from "./components/ProductPage";
import { getMenuDetails } from "./api/apiService";

// const storeId = "065896b1-9b82-415c-a178-46273b642374";


function App() {
  const [menuData, setMenuData] = useState(null); // State for menu data
  const navigate = useNavigate();
  // Fetch menu data when the app loads
  useEffect(() => {

    const storeId = localStorage.getItem("storeId");
    if (!storeId) {
    navigate("/"); // Redirect to login if storeId not found
    return;
    }
    const fetchMenuData = async () => {
      try {
        const data = await getMenuDetails(storeId);
        setMenuData(data); // Store menu data globally
      } catch (error) {
        console.error("Error fetching menu data:", error);
      }
    };

    fetchMenuData();
  }, []);

  // Function to update menu data
  const handleUpdateMenu = (updatedMenu) => {
    console.log("Updating menu data...", updatedMenu);
    setMenuData(updatedMenu);
  };

  if (!menuData) {
    return <p>Loading menu data...</p>; // Show loading screen if data is still fetching
  }

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/categories"
          element={<CategoryPage menuData={menuData} setMenuData={setMenuData} />}
        />
        <Route
          path="/products/:categoryId"
          element={
            <ProductPage
              menuData={menuData}
              onUpdateMenu={handleUpdateMenu} // Ensure this is passed correctly
            />
          }
        />
      </Routes>
    </div>
  );
}

export default App;

